define(["require", "exports", "tslib", "@material-ui/icons/Create", "@material-ui/icons/Dashboard", "@material-ui/icons/Help", "@material-ui/icons/Layers", "@material-ui/icons/Search", "mobx-react", "react", "react-router-dom", "../store/RouteStore", "../store/StoreManager", "../utils/EntityUtil", "./UserProfile", "../../dist/assets/images/QLDGovLogo-min-no-text.svg"], function (require, exports, tslib_1, Create_1, Dashboard_1, Help_1, Layers_1, Search_1, mobx_react_1, React, react_router_dom_1, RouteStore_1, StoreManager_1, EntityUtil_1, UserProfile_1, LogoImage) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ActionsView = void 0;
    Create_1 = tslib_1.__importDefault(Create_1);
    Dashboard_1 = tslib_1.__importDefault(Dashboard_1);
    Help_1 = tslib_1.__importDefault(Help_1);
    Layers_1 = tslib_1.__importDefault(Layers_1);
    Search_1 = tslib_1.__importDefault(Search_1);
    React = tslib_1.__importStar(React);
    const style = {
        icon: {
            color: "#d4d7de",
            height: "32px",
            width: "32px"
        }
    };
    let ActionsView = exports.ActionsView = class ActionsView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "dashboard", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    (0, RouteStore_1.openRoute)({ pathname: "/dashboard" });
                }
            });
            Object.defineProperty(this, "tasks", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    (0, RouteStore_1.openRoute)({ pathname: "/tasks" });
                }
            });
            Object.defineProperty(this, "search", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    (0, RouteStore_1.openRoute)({ pathname: `/search` });
                }
            });
            Object.defineProperty(this, "legend", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    (0, RouteStore_1.openRoute)({ pathname: `/legend` });
                }
            });
            Object.defineProperty(this, "help", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    const content = (React.createElement("div", null,
                        React.createElement("h3", null, "Web Resources"),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Srms_User_Guide.pdf", target: "_blank" }, "System User Guide")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Fencing_on_stock_routes.pdf", target: "_blank" }, "Fencing on stock routes")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Srms_Brand_Description.pdf", target: "_blank" }, "System Brand Description")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Stock_Route_Facility_Asset_Life.pdf", target: "_blank" }, "Stock Route Facility Asset Life")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Stock_Route_Facility_Minimum_Standards_Specifications.pdf", target: "_blank" }, "Stock Route Facility Minimum Standards Specifications")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Stock_Route_Facility_Inspections_For_Lgs.pdf", target: "_blank" }, "Stock Route Facility Inspections Procedure for Local Government")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Capital_Works_Funding_EOI_Assessment.pdf", target: "_blank" }, "Capital Works Funding EOI Assessment")),
                            React.createElement("li", null,
                                React.createElement(react_router_dom_1.Link, { to: "/documents/Capital_Works_Procedures.pdf", target: "_blank" }, "Capital Works Procedures"))),
                        React.createElement("div", { className: "br" }),
                        "For assistance, please contact",
                        " ",
                        React.createElement("a", { href: "mailto:srmssupport@nrmmrrd.qld.gov.au", target: "_blank" }, "Support")));
                    this.props.modalStore.createInfoModal("Help", content);
                }
            });
        }
        render() {
            const { uiStore } = this.props;
            return React.createElement("nav", null,
                React.createElement("ul", null,
                    React.createElement("li", { style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "rgb(212, 215, 222)",
                            gap: "5px",
                            padding: "10px 0px"
                        } },
                        React.createElement("img", { src: LogoImage.default, style: Object.assign(Object.assign({}, style.icon), { width: "50px", height: "50px", filter: "invert(1)" }) }),
                        React.createElement("div", { style: {
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                letterSpacing: "2px"
                            } }, "SRMS")),
                    React.createElement("li", null,
                        React.createElement("a", { onClick: this.dashboard },
                            React.createElement(Dashboard_1.default, { className: "sidebar-icon", style: style.icon }),
                            React.createElement("div", null, "Dashboard"))),
                    React.createElement("li", null, !this.props.entityStore.HasEntity ? (React.createElement("a", { onClick: this.tasks },
                        React.createElement(Create_1.default, { className: "sidebar-icon", style: style.icon }),
                        React.createElement("div", null, "Tasks"))) : (React.createElement("a", { onClick: this.tasks, className: "sidebar-active-task" }, (0, EntityUtil_1.prettyEntityRefId)(this.props.entityStore.entity.RefId)))),
                    React.createElement("li", null,
                        React.createElement("a", { onClick: this.search },
                            React.createElement(Search_1.default, { className: "sidebar-icon", style: style.icon }),
                            React.createElement("div", null, "Search"))),
                    !uiStore.IsMobile && !uiStore.IsTablet ? (React.createElement("li", null,
                        React.createElement("a", { onClick: this.legend },
                            React.createElement(Layers_1.default, { className: "sidebar-icon", style: style.icon }),
                            React.createElement("div", null, "Legend")))) : null,
                    React.createElement("li", null,
                        React.createElement("a", { onClick: this.help },
                            React.createElement(Help_1.default, { className: "sidebar-icon", style: style.icon }))),
                    React.createElement("li", { style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "rgb(212, 215, 222)",
                            gap: "5px",
                        } },
                        React.createElement(UserProfile_1.UserProfile, null))));
        }
    };
    exports.ActionsView = ActionsView = tslib_1.__decorate([
        (0, mobx_react_1.inject)(context => (0, StoreManager_1.injectStores)(context)),
        mobx_react_1.observer
    ], ActionsView);
});
